import axios from '@/libs/axios'
import {toastFailure} from "@/libs/toastification";

export default {
    namespaced: true,

    state: {
        addresses: [],
        activeAddressId: null,
    },

    getters: {
        addresses(state) {
            return state.addresses
        },
        activeAddressId(state) {
            return state.activeAddressId
        },
    },

    mutations: {
        SET_ADDRESSES(state, value) {
            state.addresses = Array.isArray(value) ? value : []
        },
        SET_ACTIVE_ADDRESS(state, addressId) {
            state.activeAddressId = addressId
        },
        CLEAR_ACTIVE_ADDRESS(state) {
            state.activeAddressId = null
        },
        UPDATE_ADDRESS(state, changedAddress) {
            const index = state.addresses.findIndex(address => address.id === changedAddress.id)
            Object.assign(state.addresses[index], changedAddress)
        },
        ADD_ADDRESS(state, data) {
            state.addresses.push(data);
        }
    },

    actions: {
        async loadAddresses({ commit }, customerId) {
            commit('CLEAR_ACTIVE_ADDRESS')
            return await axios.post('api/addresses/customer',
                {
                    customerId: customerId
                }).then(response => {
                    const payload = response.data?.data ?? response.data
                    const addresses = Array.isArray(payload) ? payload : []
                    commit('SET_ADDRESSES', addresses)
                    return addresses
                }).catch((error) => {
                    console.log('error: ', error);
                    throw error
                })
        },
        async updateAddress({ commit }, data) {
            return await axios.put(`api/addresses/${data.id}`, data)
                .then((response) => {
                    const saved = response.data?.data ?? response.data
                    commit('UPDATE_ADDRESS', saved)
                    return saved
                })
        },
        async addAddress({ commit }, data) {
            return await axios.post(`api/addresses`, data)
                .then((response) => {
                    const saved = response.data?.data ?? response.data
                    commit('ADD_ADDRESS', saved)
                    return saved
                })
        }
    }
}
